<script setup>
import { onMounted, ref } from 'vue';
import BreezeDropdown from '@/Components/Dropdown.vue';
import BreezeDropdownLink from '@/Components/DropdownLink.vue';
import BreezeNavLink from '@/Components/NavLink.vue';
import BreezeResponsiveNavLink from '@/Components/ResponsiveNavLink.vue';
import { Link } from '@inertiajs/inertia-vue3';
//import { useLayoutStore } from "@/stores/layout.js";
import { useStyleStore } from "@/stores/style.js";
import BaseIcon from "@/Components/BaseIcon.vue";
import { Icon } from '@iconify/vue';
import { mdiThemeLightDark, mdiWhiteBalanceSunny, mdiBell, mdiMoonWaningCrescent, mdiUmbrellaBeach } from "@mdi/js";
import UnensAlert from "@/Components/UnensAlert.vue";

onMounted(() => {
    countAlerts()
});

const alerts = ref(0);
const freedayPdte = ref(0);

const countAlerts = () => {
    countFreeday()
    countFacture()
    //alerts.value = freedayPdte.value;
}

const countFreeday = () => {
    let url = '/freeday/getcountdata';
    axios.get(url).then(function (response) {
        let respuesta = response.data;
        freedayPdte.value = respuesta.freedaypdte
        console.log('Días libres pendientes de aprob.: ' + freedayPdte.value);
    }).catch(function (error) {
        console.log(error);
    });
}

const countFacture = () => {
    let url = '/facture/getcountdata';
    axios.get(url).then(function (response) {
        let respuesta = response.data;
        alerts.value = respuesta.facturepdte
        console.log('DTE PDTE: ' + alerts.value);
    }).catch(function (error) {
        console.log(error);
    });
}

const showingNavigationDropdown = ref(false);
const styleStore = useStyleStore();

//const layoutStore = useLayoutStore();

// Menú varias opciones pero sólo seusará darklight
const menuClick = (event, item) => {
    if (item.isToggleLightDark) {
        styleStore.setDarkMode();
    }

    if (item.isLogout) {
        //
    }
};

const setDarkMode = () => {
    styleStore.setDarkMode();
}

</script>

<template>
    <div :class="{
        dark: styleStore.darkMode,
    }"><!-- class="dark" -->
        <!-- {{  styleStore.darkMode }} -->
        <div class="min-h-screen bg-white"><!-- :class="(styleStore.darkMode ? 'bg-red-100' : '')" -->
            <nav class="bg-white border-b border-gray-100">
                <!-- Primary Navigation Menu -->
                <!--<div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">-->
                <div class="mx-auto px-4 sm:px-6 lg:px-8">
                    <div class="flex justify-between h-16">
                        <div class="flex">
                            <!-- Logo -->
                            <div class="shrink-0 flex items-center">
                                <Link :href="route('dashboard')">
                                    <img v-if="confGlobal.value.COMPANY_LOGO_PATH" class="flex h-9 w-auto" :src="confGlobal.value.COMPANY_LOGO_PATH" alt="Logo">
                                </Link>
                            </div>

                            <div v-if="confGlobal.value.UNENS_SEDE_NOMBRE" class="flex items-center ml-4">
                                <div class="block ">
                                    <!-- <p class="leading-4">Sede</p> -->
                                    <h4 class="text-gray-900 text-xl font-bold leading-4">{{ confGlobal.value.UNENS_SEDE_NOMBRE }}</h4>
                                </div>
                            </div>

                            <!-- Navigation Links PC -->
                            <div class="hidden space-x-8 sm:-my-px sm:ml-10 xl:flex">
                                <BreezeNavLink :href="route('dashboard')" :active="route().current('dashboard*')">
                                    Inicio
                                </BreezeNavLink>

                                <!-- <BreezeNavLink :href="route('tercero-list')" :active="route().current('tercero-*')">
                                   Terceros
                                </BreezeNavLink> -->
                                <!-- <BreezeNavLink v-if="$page.props.auth.user.id_rol <= 4" :href="route('areaFinanciera')" :active="route().current('areaFinanciera*')">
                                    Financiera
                                </BreezeNavLink> -->
                                <BreezeDropdown v-if="$page.props.auth.user.id_rol <= 4" align="left" width="48" :useActive="true" :active="(route().current('freeday*') || route().current('collaborator*'))">
                                    <template #trigger>
                                        <span class="inline-flex rounded-md">
                                            <button type="button" class="inline-flex items-center px-3 py-2 border border-transparent text-sm leading-4 font-medium rounded-md text-gray-500 bg-white hover:text-gray-700 focus:outline-none transition ease-in-out duration-150">
                                                RRHH
                                                <svg class="ml-2 -mr-0.5 h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                                                    <path fill-rule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clip-rule="evenodd" />
                                                </svg>
                                            </button>
                                        </span>
                                    </template>

                                    <template #content>
                                        <BreezeDropdownLink :href="route('collaborator-list')" as="button">
                                            Colaboradores
                                        </BreezeDropdownLink>
                                        <!-- <BreezeDropdownLink :href="route('freeday-list')" as="button">
                                            Días Libres
                                        </BreezeDropdownLink>
                                        <BreezeDropdownLink
                                            v-if="$page.props.auth.user.id_rol <= 3"
                                            :href="route('collaborator-registroasistencia')" as="button">
                                            Registros de asistencia
                                        </BreezeDropdownLink> -->

                                    </template>
                                </BreezeDropdown>
                                <BreezeNavLink v-if="$page.props.auth.user.id_rol <= 2" :href="route('product-list')" :active="route().current('product-*')">
                                    Productos
                                </BreezeNavLink>
                                <BreezeNavLink v-if="$page.props.auth.user.id_rol <= 5" :href="route('ecommerce-config')" :active="route().current('ecommerce-*')">
                                    Ecommerce
                                </BreezeNavLink>
                                <BreezeNavLink v-if="$page.props.auth.user.id_rol <= 10" :href="route('claimlist')" :active="route().current('claimlist*') || route().current('ecommerceclaim*')">
                                    Libro de reclamaciones
                                </BreezeNavLink>
                                <!-- <BreezeNavLink v-if="$page.props.auth.user.id_rol != 8 && $page.props.auth.user.id_rol != 9" :href="route('agenda')" :active="route().current('agenda*')">
                                    Agenda
                                </BreezeNavLink> -->
                                <!-- <BreezeNavLink :href="route('report')" :active="route().current('report*')">
                                    Reportes
                                </BreezeNavLink> -->
                                <BreezeNavLink v-if="$page.props.auth.user.id_rol <= 2" :href="route('config')" :active="route().current('config*')">
                                    Configuración
                                </BreezeNavLink>

                                <!-- Más selecciones -->
                                <!--<BreezeDropdown align="right" width="48">
                                    <template #trigger>
                                        <span class="inline-flex rounded-md">
                                            <button type="button" class="inline-flex items-center px-3 py-2 border border-transparent text-sm leading-4 font-medium rounded-md text-gray-500 bg-white hover:text-gray-700 focus:outline-none transition ease-in-out duration-150">
                                                Colaboradores

                                                <svg class="ml-2 -mr-0.5 h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                                                    <path fill-rule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clip-rule="evenodd" />
                                                </svg>
                                            </button>
                                        </span>
                                    </template>

                                    <template #content>
                                        <BreezeDropdownLink :href="route('student')" method="get" as="button">
                                            Estudiantes
                                        </BreezeDropdownLink>
                                        <BreezeDropdownLink as="button">
                                            Nivel escolar
                                        </BreezeDropdownLink>
                                    </template>
                                </BreezeDropdown>-->
                            </div>
                        </div>

                        <div class="hidden xl:flex sm:items-center sm:ml-6">
                            <!-- Alertas -->
                            <div>
                                <a v-if="freedayPdte > 0 && $page.props.auth.user.id_rol <= 4" title="Días libres por aprobar" href="#" class="ml-3 inline-flex items-center text-sm font-medium leading-5 text-rose-600 hover:text-rose-700 focus:outline-none  transition duration-150 ease-in-out">
                                    <BaseIcon :path="mdiUmbrellaBeach" :size="16" /> <small>{{ freedayPdte }}</small>
                                </a>
                                <a v-if="alerts > 0 && $page.props.auth.user.id_rol <= 4" title="Comprobantes pendientes de envío" href="#" class="ml-3 inline-flex items-center text-sm font-medium leading-5 text-rose-600 hover:text-rose-700 focus:outline-none  transition duration-150 ease-in-out">
                                    <BaseIcon :path="mdiBell" :size="16" /> <small>{{ alerts }}</small>
                                </a>
                                <a href="#" class="ml-3 inline-flex items-center text-sm font-medium leading-5 text-gray-500 hover:text-rose-600 focus:outline-none transition duration-150 ease-in-out">
                                    <BaseIcon :path="(styleStore.darkMode ? mdiMoonWaningCrescent : mdiWhiteBalanceSunny)" :size="16" @click="setDarkMode()" />
                                </a>
                            </div>
                            <!-- Settings Dropdown -->
                            <div class="ml-3 relative">

                                <BreezeDropdown align="right" width="48">
                                    <template #trigger>
                                        <span class="inline-flex rounded-md">
                                            <button type="button" class="inline-flex items-center px-3 py-2 border border-transparent text-sm leading-4 font-medium rounded-md text-gray-500 bg-white hover:text-gray-700 focus:outline-none transition ease-in-out duration-150">
                                                {{ $page.props.auth.user.name }}

                                                <svg class="ml-2 -mr-0.5 h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                                                    <path fill-rule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clip-rule="evenodd" />
                                                </svg>
                                            </button>
                                        </span>
                                    </template>

                                    <template #content>
                                        <BreezeDropdownLink v-if="$page.props.auth.user.id_rol != 8" :href="route('perfil')" as="button">
                                            Mi Perfil
                                        </BreezeDropdownLink>
                                        <BreezeDropdownLink :href="route('help')" method="get" as="button">
                                            Ayuda UnensEco {{ confGlobal.value.UNENS_VERSION }}
                                        </BreezeDropdownLink>
                                        <BreezeDropdownLink :href="route('logout')" method="post" as="button">
                                            Salir
                                        </BreezeDropdownLink>
                                    </template>
                                </BreezeDropdown>
                            </div>
                        </div>

                        <!-- Hamburger -->
                        <div class="-mr-2 flex items-center xl:hidden">
                            <!-- Alertas -->
                            <div>
                                <a v-if="freedayPdte > 0 && $page.props.auth.user.id_rol <= 4" title="Días libres por aprobar" href="#" class="ml-3 inline-flex items-center text-sm font-medium leading-5 text-rose-600 hover:text-rose-700 focus:outline-none  transition duration-150 ease-in-out">
                                    <BaseIcon :path="mdiUmbrellaBeach" :size="16" /> <small>{{ freedayPdte }}</small>
                                </a>
                                <a v-if="alerts > 0 && $page.props.auth.user.id_rol <= 6" title="Comprobantes pendientes de envío" href="#" class="ml-3 inline-flex items-center text-sm font-medium leading-5 text-rose-600 hover:text-rose-700 focus:outline-none  transition duration-150 ease-in-out">
                                    <BaseIcon :path="mdiBell" :size="16" /><small>{{ alerts }}</small>
                                </a>
                                <a href="#" class="ml-3 inline-flex items-center text-sm font-medium leading-5 text-gray-500 hover:text-rose-600 focus:outline-none transition duration-150 ease-in-out">
                                    <BaseIcon :path="(styleStore.darkMode ? mdiMoonWaningCrescent : mdiWhiteBalanceSunny)" :size="16" @click="setDarkMode()" />
                                </a>
                            </div>
                            <button @click="showingNavigationDropdown = !showingNavigationDropdown" class="ml-3 inline-flex items-center justify-center p-2 rounded-md text-gray-400 hover:text-gray-500 hover:bg-gray-100 focus:outline-none focus:bg-gray-100 focus:text-gray-500 transition duration-150 ease-in-out">
                                <svg class="h-6 w-6" stroke="currentColor" fill="none" viewBox="0 0 24 24">
                                    <path :class="{ 'hidden': showingNavigationDropdown, 'inline-flex': !showingNavigationDropdown }" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h16M4 18h16" />
                                    <path :class="{ 'hidden': !showingNavigationDropdown, 'inline-flex': showingNavigationDropdown }" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
                                </svg>
                            </button>
                        </div>
                    </div>
                </div>

                <!-- 'id'=>'1', 'label'=>'Sistema', ';
                'id'=>'2', 'label'=>'Gerencial TI',
                'id'=>'3', 'label'=>'Administrador', '));
                'id'=>'4', 'label'=>'Supervisor', '
                'id'=>'5', 'label'=>'Asistente',
                -->

                <!-- Responsive Navigation Menu  Movile -->
                <div :class="{ 'block': showingNavigationDropdown, 'hidden': !showingNavigationDropdown }" class="xl:hidden">
                    <div class="pt-2 pb-3 space-y-1">
                        <BreezeResponsiveNavLink :href="route('dashboard')" :active="route().current('dashboard*')">
                            Inicio
                        </BreezeResponsiveNavLink>
                        <!-- <BreezeResponsiveNavLink :href="route('tercero-list')" :active="route().current('student-*')">
                            Terceros
                        </BreezeResponsiveNavLink> -->
                        <!-- <BreezeResponsiveNavLink v-if="$page.props.auth.user.id_rol <= 4" :href="route('areaFinanciera')" :active="route().current('areaFinanciera*')">
                            Financiera
                        </BreezeResponsiveNavLink> -->
                        <div class="pt-4 pb-1 border-t border-b border-gray-200" v-if="$page.props.auth.user.id_rol <= 3" :class="route().current('freeday*', 'collaborator*') ? 'block pl-3 pr-4 py-2 border-l-4 border-indigo-400 text-base font-medium text-indigo-700 bg-indigo-50 focus:outline-none focus:text-indigo-800 focus:bg-indigo-100 focus:border-indigo-700 transition duration-150 ease-in-out' : ''">
                            <div class="px-4">
                                <div class="font-medium text-base text-gray-800">RRHH</div>
                                <!-- <div class="font-medium text-sm text-gray-500">{{ $page.props.auth.user.email }}</div> -->
                            </div>

                            <div class="mt-3 space-y-1">
                                <BreezeDropdownLink :href="route('collaborator-list')" as="button">
                                    Colaboradores
                                </BreezeDropdownLink>
                                <!-- <BreezeDropdownLink :href="route('freeday-list')" as="button">
                                    Días Libres
                                </BreezeDropdownLink>
                                <BreezeDropdownLink v-if="$page.props.auth.user.id_rol <= 3" :href="route('collaborator-registroasistencia')" as="button">
                                    Registros de asistencia
                                </BreezeDropdownLink> -->

                            </div>
                        </div>
                        <BreezeResponsiveNavLink v-if="$page.props.auth.user.id_rol <= 2" :href="route('product-list')" :active="route().current('product-*')">
                            Productos
                        </BreezeResponsiveNavLink>
                        <BreezeResponsiveNavLink v-if="$page.props.auth.user.id_rol <= 5" :href="route('ecommerce-config')" :active="route().current('ecommerce-*')">
                            Ecommerce
                        </BreezeResponsiveNavLink>
                        <!-- <BreezeResponsiveNavLink v-if="$page.props.auth.user.id_rol != 8 && $page.props.auth.user.id_rol != 9" :href="route('agenda')" :active="route().current('agenda*')">
                            Agenda
                        </BreezeResponsiveNavLink> -->
                        <!-- <BreezeResponsiveNavLink :href="route('report')" :active="route().current('report*')">
                            Reportes
                        </BreezeResponsiveNavLink> -->
                        <BreezeResponsiveNavLink v-if="$page.props.auth.user.id_rol <= 10" :href="route('claimlist')" :active="route().current('claimlist*') || route().current('ecommerceclaim*')">
                            Libro de reclamaciones
                        </BreezeResponsiveNavLink>
                        <BreezeResponsiveNavLink v-if="$page.props.auth.user.id_rol <= 4" :href="route('config')" :active="route().current('config*')">
                            Configuración
                        </BreezeResponsiveNavLink>
                    </div>

                    <!-- Responsive Settings Options -->
                    <div class="pt-4 pb-1 border-t border-gray-200">
                        <div class="px-4">
                            <div class="font-medium text-base text-gray-800">{{ $page.props.auth.user.name }}</div>
                            <!-- <div class="font-medium text-sm text-gray-500">{{ $page.props.auth.user.email }}</div> -->
                        </div>

                        <div class="mt-3 space-y-1">
                            <BreezeDropdownLink v-if="$page.props.auth.user.id_rol != 8" :href="route('perfil')" as="button">
                                Mi Perfil
                            </BreezeDropdownLink>
                            <BreezeDropdownLink :href="route('help')" method="get" as="button">
                                Ayuda {{ confGlobal.value.UNENS_VERSION }}
                            </BreezeDropdownLink>
                            <BreezeResponsiveNavLink :href="route('logout')" method="post" as="button">
                                Salir
                            </BreezeResponsiveNavLink>
                        </div>
                    </div>
                </div>
            </nav>

            <!-- Page Heading -->
            <header class="bg-white" v-if="$slots.header">
                <!--<div class="max-w-7xl mx-auto py-6 px-4 sm:px-6 lg:px-8">-->
                <div class="px-4 sm:px-6 lg:px-8">
                    <slot name="header" />
                </div>
            </header>

            <!-- Page Content -->
            <main class="border-t">
                <UnensAlert />
                <!-- Error PP -->
                <div v-if="confGlobal.value.SHOW_ERROR_PP == 1 && $page.props.auth.user.id_rol > 1" class="mx-auto min-w-full">
                    <div class="relative md:h-[calc(100vh_-_113px)] h-[calc(100vh_-_114px)] flex flex-col items-center justify-center text-center text-white py-0 px-3 bg-slate-800">
                        <div class="absolute top-0 left-0 w-full h-full overflow-hidden">
                            <video class="min-w-full min-h-full absolute object-cover" src="/video/errorpp1301.mp4" type="video/mp4" autoplay muted loop></video>
                        </div>
                        <div class="container z-20">
                            <div class="flex flex-row justify-center">
                                <!-- Show detalle de error a menores que coordinadores -->
                                <div class="lg:basis-4/5 basis-5/5" v-if="$page.props.auth.user.id_rol < 5">
                                    <h1 class="font-bold text-5xl md:text-6xl">ERROR PP 1301</h1>
                                    <h3 class="font-semibold text-2xl md:text-4xl">SERVICIO SUSPENDIDO POR FALTA DE PAGO</h3>
                                    <p class="text-1xl md:text-3xl">Envie la constancia de pago a <b>
                                            <a href="mailto:pagos@servcom-it.com" target="_blank">pagos@servcom-it.com</a></b>. Alguna consulta escríbenos
                                        al WhatsApp <b><a href="https://wa.me/+51992640179?text=Hola" target="_blank">992 640 179</a></b>
                                    </p>
                                </div>
                                <div class="lg:basis-4/5 basis-5/5" v-else>
                                    <h1 class="font-bold text-5xl md:text-6xl">ERROR PP 1301</h1>
                                    <h3 class="font-semibold text-2xl md:text-4xl">PERMISSIONS ERROR</h3>
                                    <p class="text-1xl md:text-3xl">Consulte con su coordinador/supervisor
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <slot v-else />
            </main>
        </div>
    </div>
</template>
